module.exports = __webpack_public_path__ + "static/media/brilliwhite-2.8d6de529.jpg";